module.exports = __webpack_public_path__ + "img/GAME_RECYCLING1.0e65012f.jpg";